/*
  This component handles the logic to determine sharing story content for non-book sharing resources
  Sharing details refer to content rendered in the body of the sharing story, specific to the shared resource
  This does not include the story header or sharing text
  Sharing details for certain resource types may necessitate the creation of new react components that can be rendered here

  SharingNonBookDetails is rendered in the renderNonBookBody() method of SharingNewsfeedItem
  The content generated in renderNonBookBody() is used as the SocialUpdate body prop
*/

import { PropTypes } from "react";
import GrComponentFactory from "../../gr_component_factory";
import GroupDiscussionNewsfeedItemBody from
  "../group_discussion/group_discussion_newsfeed_item_body";
import BlogNewsfeedItemBody from "../editorial/blog_newsfeed_item_body";
import InterviewNewsfeedItemBody from "../editorial/interview_newsfeed_item_body";

export default GrComponentFactory.createClass({
  displayName: "SharingNonBookDetails",

  propTypes: {
    resourceType: PropTypes.string.isRequired,
    resourceTypeFriendlyText: PropTypes.string.isRequired,
    item: PropTypes.object,
  },

  render() {
    const classnames = "gr-newsfeedItem__details gr-newsfeedItem__details--belowContent gr-newsfeedItem__details--border";
    switch(this.props.resourceType) {
      case "Group":
        return <div className={classnames} />;
      case "Genre":
        return <div className={classnames} />;
      case "Topic":
        return <div className={classnames}><GroupDiscussionNewsfeedItemBody {...this.props.item} /></div>;
      case "Blog": {
        const classnames = "gr-newsfeedItem__details";
        return <div className={classnames}><BlogNewsfeedItemBody {...this.props.item} /></div>;
      }
      case "Interview": {
        const classnames = "gr-newsfeedItem__details";
        return <div className={classnames}><InterviewNewsfeedItemBody {...this.props.item} /></div>;
      }
      default:
        break;
    }
  },
});
